module.exports = __webpack_public_path__ + "img/41.8310dd40.png";